<template>
  <div class="calendar-layout animate__animated animate__fadeInRight">
    <div class="calendar-wrapper">
      <div class="beel-logo">
        <img src="@/assets/beel_logo.png" alt="logo_beel">
      </div>
      <calendar></calendar>
      <div class="order-wrapper">
        <div class="price-wrapper" v-if="getOrderPrice">
          {{ getOrderPrice }}
        </div>
        <custom-button class="pc-button" buttonText="Забронировать" button-type="apply" :is-blocked="isBLocked"
          @clicked="openForm"></custom-button>
        <custom-button class="mobile-button" buttonText="Выбрать места" button-type="apply" :is-blocked="false"
          @clicked="$emit('closeDataModal')"></custom-button>
      </div>
    </div>
  </div>
</template>

<script>
  import CustomButton from '../Inputs/CustomButton.vue'
  import Calendar from './Calendar.vue'
  import { EventBus } from '@/eventBus'

  export default {
    components: { CustomButton, Calendar },
    name: 'CalendarLayout',
    computed: {
      isPlaceSelected() {
        return this.$store.getters.isSelectedPlace
      },
      isBLocked() {
        return !(this.$store.state.selectedStartDate && this.$store.getters.isSelectedPlace)
      },
      getOrderPrice() {
        return this.$store.getters.orderPrice
      }
    },
    methods: {
      openForm() {
        let data = {
          bookingType: 'BOOKING',
          bookingData: null
        }
        EventBus.$emit('openForm', data)
      }
    }
  }
</script>

<style>
.calendar-layout {
  position: absolute;
  top: 0;
  left: 80%;
  width: 20%;
  height: 100vh;
  z-index: 10;
  border-radius: 20px 0 0 20px;
  border-left: 0 solid #F1F1F1;
  background: #FFF;
  box-shadow: 0 8px 8px -4px rgba(16, 24, 40, 0.03), 0 20px 24px -4px rgba(16, 24, 40, 0.08);
  display: flex;
  flex-direction: column;
}

.calendar-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 16px;
  height: 100%;
}

.price-wrapper {
  color: #344054;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  /* 150% */
  width: 100%;
  padding-bottom: 8px;
  padding-left: 4px;
}

.order-wrapper {
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  width: -webkit-fill-available;
}

.mobile-button {
  display: none !important;
}

@media (max-width: 1900px) {
  .calendar-layout {
    left: 79%;
    width: 21%;
  }
}

@media (max-width: 1700px) {
  .calendar-layout {
    left: 79%;
    width: 21%;
  }
}

@media (max-width: 1620px) {
  .calendar-layout {
    left: 77%;
    width: 23%;
  }
}

@media (max-width: 1500px) {
  .calendar-layout {
    left: 75%;
    width: 25%;
  }
}

@media (max-width: 1050px) {
  .calendar-layout {
    display: none;
    left: 0;
    width: 100%;
  }

  .calendar-layout.show {
    display: flex;
  }

  .pc-button {
    display: none !important;
  }

  .mobile-button {
    display: flex !important;
  }

  .beel-logo {
    width: 100%;
    padding-left: 24px;
    display: flex;
    justify-content: left;
  }
}

@media (max-height: 640px) {
  .beel-logo {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/CalendarComponent/CalendarLayout.vue